export default __webpack_public_path__ + "static/media/solutionset_failed.d9e4fa14.svg";